import React, { useEffect, useMemo, useState } from "react";
import {
  Alert,
  Autocomplete,
  FormControl,
  FormControlLabel,
  IconButton,
  MenuItem,
  OutlinedInput,
  Switch,
  TextField,
} from "@mui/material";
import { red, green } from "@mui/material/colors";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import CloseIcon from "@mui/icons-material/Close";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  query,
  setDoc,
  where,
} from "firebase/firestore";
import db, { auth } from "../firebase";
import { blue } from "@mui/material/colors";
import { makeStyles } from "@mui/styles";
import { useNavigate } from "react-router-dom";
import CottageIcon from "@mui/icons-material/Cottage";
import Box from "@mui/material/Box";
import { DataGrid, GridDeleteIcon } from "@mui/x-data-grid";


function BuyForm() {
  const [rows, setRows] = useState([]);
  const [dumbRows, setDumbRows] = useState([]);
  const [bulkDataId, setBulkDataId] = useState([]);
  const [bulkDataName, setBulkDataName] = useState([]);
  const [isUpdated, setUpdated] = useState({ state: false, color: "", message: "" });
  const COLORS = {
    red: "error",
    green: "success",
  };
  const [idCounter, setIdCounter] = useState(1);

  const generateId = () => {
    const currentDate = new Date();
    const day = String(currentDate.getDate()).padStart(2, '0');
    const month = String(currentDate.getMonth() + 1).padStart(2, '0');
    const year = String(currentDate.getFullYear()).slice(-2);

    const randomThreeDigits = Math.floor(Math.random() * 1000);

    const newId = `${day}${month}${year}${String(idCounter).padStart(2, '0')}${String(randomThreeDigits).padStart(3, '0')}`;
    
    setIdCounter(prevCounter => prevCounter + 1);
    return newId;
  };

  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      const colRef = collection(db, "products");
      const snapshots = await getDocs(colRef);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      setRows(docs);
    })();
  }, []);
  const currentDate = new Date().toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
  var subjects = [
    {
      value: "Income",
      label: "Income",
    },
    {
      value: "Expense",
      label: "Expense",
    },
    // {
    //   value: "Trainee",
    //   label: "Trainee",
    // },
  ];
  var categories = [
    {
      value: "Accessories",
      label: "Accessories",
    },
    {
      value: "Stationary",
      label: "Stationary",
    },
    {
      value: "Soft Toys",
      label: "Soft Toys",
    },
    {
      value: "Imported Toys",
      label: "Imported Toys",
    },
    // {
    //   value: "Trainee",
    //   label: "Trainee",
    // },
  ];
  const [currentTime, setCurrentTime] = useState("");

  useEffect(() => {
    const interval = setInterval(() => {
      const date = new Date();
      const time = date.toLocaleTimeString();
      setCurrentTime(time);
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, []);


  const SubmitButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(green[500]),
    backgroundColor: green[500],
    color: "white",
    "&:hover": {
      backgroundColor: green[700],
    },
  }));

  const [user, setUser] = useState(null);
  const [uid, setUid] = useState(null);
  const [userData, setUserData] = useState([]);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUser(user);
        setUid(user.uid);
      } else {
        setUser(null);
      }
    });

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    const fetchUserData = async () => {
      const q = query(collection(db, "users"), where("uid", "==", uid));
      const snapshots = await getDocs(q);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      setUserData(docs);
    };

    if (uid) {
      fetchUserData();
    }
  }, [uid]);

  // Access the "user" field once the data is retrieved
  useEffect(() => {
    if (userData && userData.length > 0) {
      const { userName } = userData[0];
      setUserName(userName);
    }
  }, [userData]);

  const getCurrentMonth = () => {
    const currentDate = new Date();
    const currentMonth = currentDate.getMonth() + 1;
    return currentMonth;
  };

  const getCurrentYear = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    return currentYear;
  };

  const [docRef, setDocRef] = useState();
  // var id = rows.length + dumbRows.length + 1;
  var date = currentDate;
  var time = currentTime;
  var createdOn = currentTime;
  var createdBy = userName;
  var month = getCurrentMonth();
  var year = getCurrentYear();
  var status = "PURCHASED";
  const [id, setId] = useState(generateId);
  const [subject, setSubject] = useState("INCOME");
  const [amount, setAmount] = useState("");
  const [cost, setCost] = useState("");
  const [price, setPrice] = useState("");
  const [totalAmount, setTotalAmount] = useState("");
  const [description, setDescription] = useState("");
  const [productId, setProductId] = useState("");
  const [productName, setProductName] = useState("");
  const [quantity, setQuantity] = useState("");
  const [category, setCategory] = useState("");
  const [remarks, setRemarks] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [rowId, setRowId] = useState(null);


  const handleSubjectChange = (e) => {
    setSelectedSubject(e.target.value);
  };

  const handleQuantityChange = (e) => {
    const newQuantity = e.target.value;
    setQuantity(newQuantity);
    updateTotalAmount(newQuantity, price);
  };

  const handleAmountChange = (e) => {
    const newAmount = e.target.value;
    setPrice(newAmount);
    updateTotalAmount(quantity, newAmount);
  };

  const updateTotalAmount = (newQuantity, newAmount) => {
    const calculatedTotalAmount =
      parseFloat(newQuantity) * parseFloat(newAmount);
    setTotalAmount(isNaN(calculatedTotalAmount) ? "" : calculatedTotalAmount);
  };

  useEffect(() => {
    (async () => {
      const colRef = collection(db, "products");
      const snapshots = await getDocs(colRef);
      const docs = snapshots.docs.map((doc) => {
        let data = doc.data();
        data.id = doc.id;
        return data;
      });
      const ids = docs.map((row) => {
        return row.productId;
      });
      const names = docs.map((row) => {
        return row.productName;
      });
      setBulkDataId(ids);
      setBulkDataName(names);
    })();
  }, []);

  const uniqueItems = [...new Set(rows.map((i) => i.productId))];
  const uniqueItem = uniqueItems.length === 1 ? uniqueItems[0] : uniqueItems;
  const uniqueId = Array.isArray(uniqueItem)
    ? uniqueItem.map((value) => <span key={value}>{value}, </span>)
    : uniqueItem;

  // const handleProductIdChange = (e, newValue) => {
  //   const isIdInBulkData = bulkDataId.includes(productId);
  //   e.preventDefault();
  //   if (isIdInBulkData === true) {
  //   setProductId(newValue);
  //   (async () => {
  //     const colRef = collection(db, "products");
  //     const itemRef = query(colRef, where("productId", "==", newValue));
  //     const snapshots = await getDocs(itemRef);
  //     const docItemRef = doc(db, "products", snapshots.docs[0].productId);
  //     const docs = snapshots.docs[0].data();
  //     console.log(docs.description);
  //     if (docs.productId === newValue) {
  //       setProductName(docs.productName);
  //       setCategory(docs.category);
  //       setSubject(docs.subject);
  //       setAmount(docs.amount);
  //       setDescription(docs.description);
  //       setQuantity(docs.quantity);
  //       setTotalAmount(docs.totalAmount);
  //     }
  //     // setDocRef(docItemRef);
  //   })();
  // }
  // else{
  //   setProductId(e.target.value);
  // }
  // };

  const columns = useMemo(
    () => [
    { field: "productId", headerName: "Product Id", width: 100 },
    {
      field: "productName",
      headerName: "Product name",
      width: 150,
      editable: true,
    },
    {
      field: "category",
      headerName: "Category",
      width: 150,
      editable: true,
    },
    {
      field: "price",
      headerName: "Price",
      type: "number",
      width: 110,
      editable: true,
    },
    {
      field: "amount",
      headerName: "Amount",
      type: "number",
      width: 120,
      editable: true,
    },
    {
      field: "quantity",
      headerName: "Quantity",
      type: "number",
      width: 110,
      editable: true,
    },
    {
      field: "totalAmount",
      headerName: "Total Amount",
      type: "number",
      width: 140,
      editable: true,
    },
    {
      field: "actions",
      headerName: "Actions",
      type: "actions",
      renderCell: (params) => <Actions params={params} />,
      width: 120,
      headerClassName: "super-app-theme--header",
    },
  ],
  [rowId]
  )

  //Add
  const addItem = () => {
    generateId();
    setId(generateId());
    console.log(id)
    if(productId != "" && productName != "" && category != "" && price != "" && amount != "" && quantity != ""){
    const newItem = {
      id,
      productId,
      productName,
      category,
      date,
      time,
      month,
      year,
      subject: "INCOME",
      // remarks,
      // description,
      quantity,
      amount,
      price,
      totalAmount,
      createdOn,
      createdBy,
      status,
    };

    const newArray = [...dumbRows, newItem];
    // updateIds(rows, newArray);
    setDumbRows(newArray);
    handleClear();
  }
  else{
    setUpdated({ state: true, color: COLORS.red, message:"Please Fill Mandatory"  });
          setTimeout(() => {
            setUpdated({ state: false, color: COLORS.red, message:"Please Fill Mandatory" });
          }, 8000);
  }
  };

  const updateIds = (rows, dumbRows) => {
    dumbRows.forEach((item, index) => {
      const newId = rows.length + dumbRows.length + index + 1;
      item.id = newId;
    });
  };

  //Remove

//   const removeItemById = (id) => {
//     console.log(dumbRows)
//     console.log(id)
//     const updatedItems = dumbRows.filter(item => item.id !== id);
//     setDumbRows(updatedItems);
//     const updatedData = dumbRows.map(item => ({
//       ...item,
//       id: (parseInt(item.id, 10) - 1).toString()
//     }));
//     setDumbRows(updatedData);
// };

const removeItemById = (id) => {
  setDumbRows((prevRows) => {
    const updatedItems = prevRows.filter((item) => item.id !== id);
    // updateIds(rows, updatedItems);
    console.log(updatedItems);
    return updatedItems;
  });
  // dumbRows.forEach(i => {
  //   id = rows.length + dumbRows.length + 1;
  //   i.id = id;
  // });
  // console.log(dumbRows)
};


  //Submit
  const handleSubmit = async (e) => {
    const isIdInBulkData = bulkDataId.includes(productId);
    e.preventDefault();
    if (isIdInBulkData === true) {
      e.preventDefault();
      const colRef = collection(db, "products");
      const itemRef = query(colRef, where("productId", "==", productId));
      const snapshots = await getDocs(itemRef);
      const docs = snapshots.docs[0].data();

      if (!snapshots.empty) {
        const firstDoc = snapshots.docs[0];
        const docItemRef = doc(db, "products", firstDoc.id);
        const docItemRef1 = doc(db, "transactions", firstDoc.id);
        const docData = firstDoc.data();

        const updatedQuantity =
          parseInt(docData.quantity, 10) + parseInt(quantity, 10);
        const updatedTotalAmount =
          parseInt(docData.totalAmount, 10) + parseInt(totalAmount, 10);

        try {
          await setDoc(docItemRef, {
            id: docs.id,
            date: date,
            time: time,
            month: month,
            year: year,
            createdOn: docs.createdOn,
            createdBy: docs.createdBy,
            modifiedOn: time,
            modifiedBy: userName,
            productId: productId,
            productName: productName,
            category: category,
            // remarks: remarks,
            // description: description,
            subject: "INCOME",
            quantity: updatedQuantity,
            amount: amount,
            price: price,
            totalAmount: updatedTotalAmount,
            status: status,
          });
          await setDoc(docItemRef1, {
            id: docs.id,
            date: date,
            time: time,
            month: month,
            year: year,
            createdOn: docs.createdOn,
            createdBy: docs.createdBy,
            modifiedOn: time,
            modifiedBy: userName,
            productId: productId,
            productName: productName,
            category: category,
            // remarks: remarks,
            // description: description,
            subject: "INCOME",
            quantity: quantity,
            amount: amount,
            price: price,
            totalAmount: totalAmount,
            status: status,
          });
          setUpdated({ state: true, color: COLORS.green });
          setTimeout(() => {
            setUpdated({ state: false, color: COLORS.green });
          }, 8000);
          alert("Updated Successfully");
          navigate("/index");
        } catch (err) {
          setUpdated({ state: true, color: COLORS.red });
          setTimeout(() => {
            setUpdated({ state: false, color: COLORS.red });
          }, 8000);
        }
      }
    } else {
      if (Array.isArray(dumbRows) && dumbRows.length > 0) {
          for (const i of dumbRows) {
            await addDoc(collection(db, "products"), {
              id:i.id,
              productId:i.productId,
              productName:i.productName,
              category:i.category,
              date:i.date,
              time:i.time,
              month:i.month,
              year:i.year,
              subject: "INCOME",
              // remarks: remarks,
              // description:i.description,
              quantity:i.quantity,
              amount:i.amount,
              price:i.price,
              totalAmount:i.totalAmount,
              createdOn:i.createdOn,
              createdBy:i.createdBy,
              status:i.status,
            });
        await addDoc(collection(db, "transactions"), {
          id:i.id,
              productId:i.productId,
              productName:i.productName,
              category:i.category,
              date:i.date,
              time:i.time,
              month:i.month,
              year:i.year,
              subject: "INCOME",
              // remarks: remarks,
              // description:i.description,
              quantity:i.quantity,
              amount:i.amount,
              price:i.price,
              totalAmount:i.totalAmount,
              createdOn:i.createdOn,
              createdBy:i.createdBy,
              status:i.status,
        })
          .then((res) => {
            setUpdated({ state: true, color: COLORS.green,message: dumbRows.length + " Data Submitted Successfully" });
            setTimeout(() => {
              setUpdated({ state: false, color: COLORS.green,message: dumbRows.length + " Data Submitted Successfully" });
            }, 3000);
            setDumbRows([]);
            // alert("Added Successfully");
          })
          .catch((err) => {
            setUpdated({ state: true, color: COLORS.red, message:"Submission failed" });
            setTimeout(() => {
              setUpdated({ state: false, color: COLORS.red, message:"Submission failed" });
            }, 3000);
          });
        // navigate("/index");
        }
      } else {
        setUpdated({ state: true, color: COLORS.red,message: "Please!.. Fill Mandatory" });
            setTimeout(() => {
              setUpdated({ state: false, color: COLORS.red,message: "Please Add atleast one item to submit" });
            }, 3000);
        // alert("Please!.. Fill Mandatory");
      }
    }
    handleClear();
  };

  const handleClear = () => {
    setSubject("INCOME");
    setAmount("");
    setCost("");
    setPrice("");
    setTotalAmount("");
    setDescription("");
    setProductId("");
    setProductName("");
    setQuantity("");
    setCategory("");
    setRemarks("");
    setSelectedSubject("");
  };

  const Actions = ({params}) => {
    const rId = params.row.id;
    return (
      <div className="action-buttons">
        {/* <IconButton
          onClick={() => {
            console.log(params.params.row);
            setIsEditVisible(!isEditVisible);
            setForm(params.params.row);
          }}
          aria-label="edit"
        >
          <EditIcon />
        </IconButton> */}
        <IconButton aria-label="delete" onClick={() => removeItemById(rId)} >
          <GridDeleteIcon />
        </IconButton>
      </div>
    );
  };

  const AddButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText(blue[500]),
    backgroundColor: "#1f1966",
    borderRadius: "10px",
    "&:hover": {
      backgroundColor: "#1f1979",
    },
  }));

  const handleNav = () => {
    navigate("/index");
  };

  return (
    <>
    {isUpdated.state && (
      <Alert
        severity={isUpdated.color}
        style={{
          position: "fixed",
          marginTop: "80px",
          marginLeft:"10px",
          zIndex: "1000",
        }}
      >
        &ensp;{isUpdated.message}
      </Alert>
    )}
    <div className="wrapper"  >
    
      <div className="form-container">
        {/* <Button
        startIcon={<CottageIcon />}
        onClick={handleNav}
        variant="contained"
        sx={{ position: "relative", top: "10px", width: "400px" }}
      >
        Home
      </Button> */}
        <div className="inputs">
          <label htmlFor="product-input">
            Product Id <span style={{ color: "red" }}>*</span>
          </label>
          <br />
          <OutlinedInput
            sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
            placeholder="Please enter Id"
            value={productId}
            onChange={(e) => {
              setProductId(e.target.value);
            }}
          />
        </div>
        <div className="inputs">
          <label htmlFor="input">
            Product Name <span style={{ color: "red" }}>*</span>
          </label>
          <br />
          <OutlinedInput
            sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
            placeholder="Please enter Name"
            value={productName}
            onChange={(e) => {
              setProductName(e.target.value);
            }}
          />
        </div>
        <div className="inputs">
          <label htmlFor="input">
            Category <span style={{ color: "red" }}>*</span>
          </label>
          <br />
          <TextField
            id="outlined-select-currency"
            select
            sx={{ width: "37ch", padding: "0px" }}
            className="dropdown"
            value={category}
            onChange={(e) => setCategory(e.target.value)}
          >
            {categories.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </div>
        <div className="inputs">
          <label htmlFor="amount">
            Price <span style={{ color: "red" }}>*</span>
          </label>
          <br />
          <OutlinedInput
            sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
            placeholder="Please enter price"
            value={price}
            onChange={handleAmountChange}
          />
        </div>
        <div className="inputs">
          <label htmlFor="amount">
            Cost <span style={{ color: "red" }}>*</span>
          </label>
          <br />
          <OutlinedInput
            sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
            placeholder="Please enter amount"
            value={amount}
            onChange={(e) => {
              setAmount(e.target.value);
            }}
          />
        </div>
        <div className="inputs">
          <label htmlFor="quantity">
            Quantity <span style={{ color: "red" }}>*</span>
          </label>
          <br />
          <OutlinedInput
            sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
            placeholder="Please enter quantity"
            value={quantity}
            onChange={handleQuantityChange}
          />
        </div>
        <div className="inputs">
          <label htmlFor="totalAmount">
            Total Amount <span style={{ color: "red" }}>*</span>
          </label>
          <br />
          <OutlinedInput
            sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
            placeholder="Total amount will be calculated"
            value={totalAmount}
            readOnly
          />
        </div>
        {/* <div className="inputs">
          <label htmlFor="input">Remarks</label>
          <br />
          <OutlinedInput
            sx={{ height: "3.5ch", padding: "0px", width: "36ch" }}
            placeholder="Please enter Remarks"
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
          />
        </div>
        <div className="inputs">
          <label htmlFor="input">
            Description <span style={{ color: "red" }}>*</span>
          </label>
          <br />
          <TextField
            id="outlined-multiline-static"
            multiline
            rows={4}
            sx={{ width: "37ch" }}
            placeholder="Please enter text"
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          />
        </div> */}
      </div>

        <div className="buttons">
          <Button variant="outlined" color="error" onClick={handleClear}>
            Clear
          </Button>
          <Button variant="contained" className="submit" onClick={addItem}>
            Add
          </Button>
        </div>

      <div className="table-container">
        {dumbRows.length > 0 ? (
          <Box sx={{ height: "100%", width: "80%" }}>
            <DataGrid
              rows={dumbRows}
              columns={columns}
              getRowId={(row) => row.id}
              // checkboxSelection
              // disableRowSelectionOnClick
            />
          </Box>
        ) : (
          <p>Add more.. </p>
        )}
        <SubmitButton
          variant="contained"
          className="submit"
          onClick={handleSubmit}
        >
          Submit
        </SubmitButton>
      </div>
    </div>
    </>
  );
}

export default BuyForm;
